import { useMutation } from "react-query";
import api from "../../client";
import {
  InstitutionRanking,
  UpdateInstitutionRankingPayload,
} from "../../types/institution-ranking";

const patchData = async (
  id: string | undefined,
  payload: UpdateInstitutionRankingPayload,
): Promise<InstitutionRanking> => {
  const { data } = await api.patch(`/institution-ranking/${id}`, payload);

  return data;
};

export const useUpdateInstitutionRanking = (id: string | undefined) => {
  return useMutation((payload: UpdateInstitutionRankingPayload) => {
    return patchData(id, payload);
  });
};
